<div class="payment_method__form_wrapper">
    <div>
        <div class="payment-method__form">
            <h1 class="block-title">{{ 'text_addPaymentMethod' | dbText }}</h1>
            <div class="db-stripe-errors" *ngIf="stripeErrors">{{ stripeErrors }}</div>
            <div class="payment-method__group payment-method__card-info">
                <!-- Stripe Payment Element -->
                @if (!isPayPalProvider) {
                    <div id="payment-element" class="embedded-payment-element"></div>
                }
                <!-- PayPal Card Fields -->
                @if (isPayPalProvider) {
                    <div class="paypal-card-fields">
                        <div class="paypal-field-group">
                            <label>{{ 'text_cardNumber' | dbText }}</label>
                            <div id="card-number" class="paypal-card-field"></div>
                        </div>
                        <div class="paypal-field-row">
                            <div class="paypal-field-group">
                                <label>{{ 'text_expireDate' | dbText }}</label>
                                <div id="card-expiry" class="paypal-card-field"></div>
                            </div>
                            <div class="paypal-field-group">
                                <label>CID/CVV</label>
                                <div id="card-cvv" class="paypal-card-field"></div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div>
        <div class="payment-method__form payment-method__trial">
            <div class="payment-method__group">
                <a class="ds-btn-purple-blue ds-btn-m" [class.ds-btn-disabled]="loadingConfirm" (click)="confirm()">
                    <span *ngIf="!loadingConfirm">{{ "text_addCreditCard" | dbText}}</span>
                    <db-loading-circular-spinner *ngIf="loadingConfirm"></db-loading-circular-spinner>
                </a>
            </div>
        </div>
    </div>
    <db-loading-screen [ngClass]="{'hidden':!loadingStripe}"></db-loading-screen>
</div>
